import React, {useState} from 'react';
import { Form } from 'react-final-form';
import { Button } from 'reactstrap';
import formValidation from "@/shared/validation/editprogramuser";
import axios from 'axios';
import { fetchUser, fetchRoles, fetchUserProgramRoles } from "@/shared/apiHelper"
import {unpatchSelect, labelizeNamedData, buildIdArray} from '@/shared/helpers'
import {useDispatch, flashSuccess, flashError} from "@/shared/components/flash"
import ProgramUserFormFields from './ProgramUserFormFields'
import arrayMutators from "final-form-arrays"
import getUnitNumbers from '@/services/program/getUnitNumbers';
import {getPositionLevels} from '@/services/program/position';
import { isObject } from '@/shared/helpers';

let config = {
  roles:[],
  roleInput: 'checkbox',
  roleField: 'roles',
  rolePlaceholder: 'Select Role',
  roleDisable: false,
  isProgram: false,
  unitNumberField: 'unit_number',
  unitNumberOptions: [],
  positionLevelField: 'position_level',
  positionLevelOptions: []
}

const isSuperAdminRole = (role) => {
  const roleName = String(
    role?.name || role?.label || role?.slug || role?.code || ''
  ).trim().toLowerCase();

  return roleName === 'super admin' || roleName === 'super-admin' || roleName === 'super_admin';
}

const getBirthday = (user) => {
    if(user.dob){
        let dateParts = user.dob.split('-');
        let month = dateParts[1];
        let day = dateParts[2];
        user.month = month;
        user.day = day;
    }
    return user;
}

const setBirthday = (values) => {
    if(values.day && values.month){
        let month = isObject(values.month)? values.month.value : values.month
        let day = isObject(values.day)? values.day.value : values.day
        values.dob = formatDate(month, day)
    }
    return values;
}

const formatDate = (month, day) => {
  let year = String(1).padStart(4, '0');
  month = String(month).padStart(2, '0');
  day = String(day).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

const EditProgramUserForm = ({organization, program, userid, toggle, setTrigger}) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [roles, setRoles] = useState(null)
    const [programRoles, setProgramRoles] = useState(null)
    const [unitNumberOptions, setUnitNumberOptions] = useState(config.unitNumberOptions);
    let [user, setUser] = useState(null)
    const [positionLevelOptions, setPositionLevelOptions] = useState(config.positionLevelOptions);

    React.useEffect( () => {
        getRoles(program.organization_id);
        fetchUser(program.organization_id, userid)
        .then( data => {
            data.avatar = null;
            setUser(data);
            setLoading(false)
        })

        fetchUserProgramRoles(program.organization_id, userid, program.id)
        .then( _roles => {
            // console.log(_roles)
            // const _roles = extractRolesFromProgramPermissions(_permissions, program.id);
            setProgramRoles(buildIdArray(_roles))
        })
    }, [program])

    React.useEffect( () => {
        
    }, [user])

    React.useEffect(() => {
      if (organization?.id && program?.id && program?.uses_units) {
        getUnitNumbers(organization.id, program.id, "assignable=1").then( res => {
          setUnitNumberOptions(labelizeNamedData(res));
        })
      }
    }, [organization, program]);


    const getRoles = ( organizationId ) => {
        setLoading(true)
        fetchRoles( organizationId, 1 )
        .then( data => {
            data = Array.isArray(data) ? data.filter((role) => !isSuperAdminRole(role)) : data;

            if( config.roleInput === 'select')    {
                data = labelizeNamedData(data);
            }
            
            setRoles(data);
            setLoading(false)
        })
    }

    React.useEffect(() => {
      if (
        organization?.id &&
        program?.id &&
        (program?.use_budget_cascading > 0 ||
          program?.use_cascading_approvals > 0)
      ) {
        getPositionLevels(organization.id, program.id, "assignable=1").then(
          (res) => {
            setPositionLevelOptions(
              labelizeNamedData(res, ["id", "title"])
            );
          }
        );
      }
    }, [organization, program]);

   
  
    const onSubmit = values => {
        if (values.award_level && values.award_level.value) {
            values.award_level = values.award_level.value;
        }

        if( config.roleInput === 'select')    {
            values = unpatchSelect(values, [config.roleField])
        }
        if( typeof values.unit_number === 'object') {
          values = unpatchSelect(values, [config.unitNumberField])
        }
        if( typeof values.position_level === 'object') {
            values = unpatchSelect(values, [config.positionLevelField])
          }
        const availableRoleIds = new Set(
          Array.isArray(roles) ? roles.map((role) => String(role.id)) : []
        );
        // setLoading(true)
        values = setBirthday(values)
        let userData = {
          first_name: values.first_name,
          last_name: values.last_name,
          roles: Array.isArray(values.roles)
            ? values.roles.filter((roleId) => availableRoleIds.has(String(roleId)))
            : values.roles,
          user_status_id: values.user_status_id,
          email: values.email,
          phone: values.phone || null,
          country_id: values.country_id?.value ?? values.country_id,
          award_level: values.award_level,
          work_anniversary: values.work_anniversary,
          dob: values.dob,
          division: values.division,
          employee_number: values.employee_number,
          supervisor_employee_number: values.supervisor_employee_number,
          password: values.password,
          password_confirmation: values.password_confirmation,
          is_organization_admin: values.is_organization_admin
      }
      axios.put(`/organization/${program.organization_id}/program/${program.id}/user/${userid}`, userData)
        .then( (res) => {
            // console.log(res)
            if(res.status < 300)  {
                toggle()
                setTrigger( Math.floor(Date.now() / 1000) )
                flashSuccess(dispatch, "User Updated successfully!")
            }
            setLoading(false)
        })
        .catch( error => {
            flashError(dispatch, error.response.data)
            setLoading(false)
        })
    }

    const validate = async(values) => {
        // console.log(values)
        let v1 = await formValidation.validateForm(values)

        v1 = v1 ? v1 : {}

        // if( !values.password )  {
        //     v1.password = 'Password is required'
        // }
        // if( !values.password_confirmation )  {
        //     v1.password_confirmation = 'Confrim Password is required'
        // } else 
        
        if( ( values.password || values.password_confirmation ) && values.password !== values.password_confirmation )  {
            v1.password_confirmation = 'Passwords do not match'
        }
        // console.log(v1)
        return v1
    }

    if( !roles ) return 'Loading...'

    config = {...config, ...{roles}}
    const availableRoleIds = new Set(
      Array.isArray(roles) ? roles.map((role) => String(role.id)) : []
    );
    if(user && !user.role_id){
        delete(user.role_id);
    }
    
    user = {...user, ...{
      roles: Array.isArray(programRoles)
        ? programRoles.filter((roleId) => availableRoleIds.has(String(roleId)))
        : programRoles
    }}
    // console.log(user.roles)
    user.user_status_id = String(user.user_status_id ? user.user_status_id : "")
    user.unit_number = String(user?.unitNumber?.id ? user.unitNumber.id : "")
    user.position_level = String(user?.positionLevel?.id ? user.positionLevel.id : "")
    user.is_organization_admin = user.isAdmin
    // user.unit_number = "2"
    // // console.log(user.user_status_id)
    // console.log("user.unit_number")
    // console.log(typeof user.unit_number)
    user = getBirthday(user)

    return (
    <Form
        onSubmit={onSubmit}
        validate={validate}
        initialValues={user}
        mutators={{
            ...arrayMutators
        }}
    >
    {({ handleSubmit, form, submitting, pristine, values }) => {
    return (
        <form className="form" onSubmit={handleSubmit}>
            <div className="manager-program-modal__form-head">
                <h4 className="manager-program-modal__form-title">User Details</h4>
                <p className="manager-program-modal__form-copy">
                    Update profile data, access, and program-specific settings.
                </p>
            </div>
            <ProgramUserFormFields config={{...config, ...{
              unitNumberOptions }, ...{positionLevelOptions
            }}} form={form} submitting={submitting} pristine={pristine} values={values} program={program}/>
            <div className="manager-program-modal__footer-actions">
                <Button type="submit" disabled={loading} className="btn btn-primary" color="#ffffff">
                    Save Changes
                </Button>
            </div>
        </form>
    )}}
    </Form>
)}

export default EditProgramUserForm;
